import { render } from "./Popup.vue?vue&type=template&id=9fa8bf92&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=9fa8bf92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9fa8bf92"

export default script